// 模块库
const state = {
  // 专业聚合[string]
  specialtyTypeAgg: [],
  // 功能类型聚合[string]
  functionTypeAgg: []
}
const getters = {
  specialtyTypeOptions: (state) => state.specialtyTypeAgg.map((item) => {
    return { name: item, code: item }
  }),
  functionTypeOptions: (state) => state.functionTypeAgg.map((item) => {
    return { name: item, code: item }
  }),
}
const mutations = {
  setOptionsAgg(state, objData) {
    const { softwareVersions, types, specialtyType, functionType } = objData
    state.softwareVersionAgg = softwareVersions || []
    state.moduleTypeAgg = types || []
    state.specialtyTypeAgg = specialtyType || []
    state.functionTypeAgg = functionType || []
  },
}
const actions = {
  // 获取选项聚合
  async loadOptionsAgg({ commit }, payload) {
    try {
      const res = await this.$api.module.optionsAgg(payload)
      commit('setOptionsAgg', res || {})
    } catch (error) {
      commit('setOptionsAgg', {})
    }
  },

}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
